// 2026-08-30 - Central platform/app-context detection for PWA support. Reuses the SAME
// feature-detection pattern already used across the app (window.Android*Bridge presence),
// never user-agent-only for WebView detection, so the existing Android WebView APK is never
// accidentally mistaken for a browser/PWA context (and vice versa).

export function isAndroidWebView() {
  return (
    typeof window.AndroidFCMBridge !== "undefined" ||
    typeof window.AndroidReferralBridge !== "undefined" ||
    typeof window.AndroidPaymentBridge !== "undefined" ||
    typeof window.AndroidPdfBridge !== "undefined"
  );
}

export function isStandalonePwa() {
  return (
    (typeof window.matchMedia === "function" && window.matchMedia("(display-mode: standalone)").matches) ||
    window.navigator.standalone === true // iOS Safari's own standalone flag
  );
}

export function isIosDevice() {
  const ua = navigator.userAgent || "";
  return /iPad|iPhone|iPod/.test(ua) || (ua.includes("Macintosh") && navigator.maxTouchPoints > 1);
}

export function isIosSafariBrowserTab() {
  return isIosDevice() && !isAndroidWebView() && !isStandalonePwa();
}

// One of: "android_webview" | "ios_pwa" | "ios_safari" | "pwa" | "browser"
export function getAppContext() {
  if (isAndroidWebView()) return "android_webview";
  if (isIosDevice() && isStandalonePwa()) return "ios_pwa";
  if (isIosDevice()) return "ios_safari";
  if (isStandalonePwa()) return "pwa";
  return "browser";
}
